import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "./contact.css";
import ContactPageImg from "../../assets/contactPage/rightSideImage.png";
import { Link } from "react-router-dom";

function ContactPage() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="contactPage" data-aos="fade-up">
      <div className="contentContainer">
        <div className="textSection" data-aos="fade-right">
          <h1 className="heading">Let's Build Something Amazing Together!</h1>
          <p className="contactDescription">
            Welcome to my contact page! Whether you're here to discuss a new
            project, collaborate on an idea, or simply say hello, I'd love to
            hear from you.
          </p>
          <div className="buttonContainer" data-aos="zoom-in">
            <Link to="/contactform">
              <button className="contactCallToActionbutton">
                BOOK A FREE CALL
              </button>
            </Link>
          </div>
        </div>
        <figure className="networkVisual" data-aos="fade-left">
          <img
            src={ContactPageImg}
            alt="Network of connected profile avatars"
            className="networkImage"
          />
        </figure>
      </div>
    </section>
  );
}

export default ContactPage;
